module.exports = __webpack_public_path__ + "static/media/phone.3e473807.svg";